import { track } from "../../../analytics";

const UnclaimedOrEmpty = (props) => {
    const {
        text,
        subtext,
        linkText,
        unclaimed,
        firmId,
        claimProfileUrl,
        utmTerm,
    } = props;
    
    const handleButtonClick = () => {
        track(`Clicked ${linkText} button on unclaimed profile`, {
            category: 'firm_profile',
            firmId: firmId,
        });
    };

    return (
        <>
            <p
                className={`text-[1.1rem] text-center font-normal leading-6 ${
                    unclaimed ? 'text-cherry-red' : 'text-primary-blue'
                }`}
            >
                {text}
            </p>
            {unclaimed && (
                <div className="flex flex-col items-center justify-center flex-wrap leading-none">
                    <p className="text-[1.1rem] font-bold leading-6">{subtext}</p>
                    <a
                        className="text-[1.1rem] font-bold"
                        onClick={handleButtonClick}
                        href={`${claimProfileUrl}&utm_term=${utmTerm}`}
                        target="_blank"
                    >
                        {linkText}
                    </a>
                </div>
            )}
        </>
    );
};

export default UnclaimedOrEmpty;
